'use strict'
import Vue from 'vue'
import { api } from '@/services/api'

export default {
  namespaced: true,
  state: {},
  getters: {
    main: (state) => (key) => {
      return state[key]
    }
  },
  mutations: {
    create (state, { key, url, uid }) {
      Vue.set(state, key, { lastUpdate: (new Date()).getTime(), urls: { [url]: { [uid]: 1 } } })
    },
    lastUpdate (state, key) {
      state[key].lastUpdate = (new Date()).getTime()
    },
    addWatcher (state, { key, url, uid }) {
      if (state[key]) {
        if (state[key].urls[url]) {
          state[key].urls[url][uid] = 1
        } else {
          state[key].urls[url] = { [uid]: 1 }
        }
      } else {
        // eslint-disable-next-line
        console.warn('error add watcher flag in store', { key, url, uid })
      }
    },
    removeWatcher (state, { key, url, uid }) {
      try {
        delete state[key].urls[url][uid]
      } catch (e) {
        // eslint-disable-next-line
        console.warn('error remove watcher flag in store', e)
      }
    }
  },
  actions: {
    update ({ state, commit, dispatch }, key) {
      if (state[key] && Object.keys(state[key].urls).length) {
        commit('lastUpdate', key)
        _.each(state[key].urls, (item, url) => {
          if (Object.keys(item).length) dispatch('load', url)
        })
      }
    }
  },
  modules: {
    urls: {
      state: {},
      getters: {
        url: (state) => (url) => {
          return state[url]
        }
      },
      mutations: {
        createUrl (state, { key, url }) {
          Vue.set(state, url, { map: {}, records: [], isLoading: true, lastUpdate: null })
        },
        setData (state, { url, data }) {
          state[url] = data
        }
      },
      actions: {
        load ({ commit, state }, url) {
          commit('setData', { url, data: { isLoading: true, lastUpdate: state[url].lastUpdate, records: [], map: {} } })
          api
            .get(`${url}`, { requestId: `apiData|${url}` })
            .then(response => {
              if (response.data) {
                commit('setData', {
                  url,
                  data: response.data.value.reduce((acc, value, index) => {
                    value.order_ = index
                    acc.records.push(value)
                    acc.map[value.id] = value
                    // acc.mapLabels[value.labelKey] = value
                    return acc
                  }, { isLoading: false, lastUpdate: (new Date()).getTime(), records: [], map: {}, mapLabels: {} })
                })
              } else {
                // new Noty({
                //   type: 'error',
                //   text: (response.data.Message || 'Не удалось загрузить данные') + ' (' + params.url + ')'
                // }).show()
              }
            })
        }
      }
    }
  }
}
